import { lazy, Suspense } from 'react';
import Loader from '../custom/loader/main'

const Main = lazy(() => import('../components/transcript/requests/main'));

const Requests = () =>{
return(
    <Suspense fallback={<Loader/>}>
        <Main/>
    </Suspense>
)



}

export default Requests;